import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Spinner,
  Stack,
  Switch,
  Table,
  Tbody,
  Td,
  Text,
  Textarea,
  Th,
  Thead,
  Tr,
  useBreakpointValue,
  useToast,
  Skeleton,
  Tooltip,
} from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Header } from '../../../components/Header'
import { Sidebar } from '../../../components/Sidebar'
import { CardContainer } from '../../../components/molecules/CardContainer'
import Picker from 'emoji-picker-react'
import { Link } from 'react-router-dom'
import { FiEdit } from 'react-icons/fi'
import { NotFound } from '../../../components/molecules/NotFound'
import { Pagination } from '../../../components/PaginationNew'
import { AddIcon, CloseIcon } from '@chakra-ui/icons'
import { WhatsAppMessagePreviewReal } from '../../../components/WhatsappPreview'
import { apiAuth } from '../../../services/apiAuth'
import axios from 'axios'


type HistoryRecord = {
  id: number
  envioData: string
  startTime: string
  endTime: string
  successCount: number
  failureCount: number
}

export default function BirthdayScreen() {
  const [t] = useTranslation('pageBirthdayPeople')
  const toast = useToast()
  const isWideVersion = useBreakpointValue({ base: false, lg: true })

  const [isLoading, setIsLoading] = useState(true)
  const [isLoadingSave, setIsLoadingSave] = useState(false)
  const [message, setMessage] = useState(``)
  const [socialKeyword] = useState('social_name')
  const [isActive, setIsActive] = useState(false)
  const [scheduleTime, setScheduleTime] = useState('09:00')
  const [photo, setPhoto] = useState<File | string | null>(null)
  const [showEmoji, setShowEmoji] = useState(false)
  const [previewUrl, setPreviewUrl] = useState<string | null>(null)

  const [lastStartTime, setLastStartTime] = useState('')
  const [lastEndTime, setLastEndTime] = useState('')
  const [successCount, setSuccessCount] = useState<number | null>(null)
  const [failureCount, setFailureCount] = useState<number | null>(null)

  const [historyData, setHistoryData] = useState<HistoryRecord[]>([])
  const [currentPage, setCurrentPage] = useState(1)
  const [totalCountOfPage, setTotalCountOfPage] = useState(0)
  
  const [configId, setConfigId] = useState("")
  const [clinicId, setClinicId] = useState("")

  async function fetchConfig() {
    try {
      const { data } = await apiAuth.get('clinics/whatsapp/automation/config/')
      if (data) {
        setConfigId(data.id)
        setMessage(data.message_text || "")
        setScheduleTime(data.send_time || '09:00')
        setIsActive(data.is_active || false)
        setClinicId(data?.clinic)
        if (data.image) {
          setPreviewUrl(data.image)
          setPhoto(data?.image)
        }
      }
    } catch (err) {
      toast({ title: 'Erro ao carregar configuração', status: 'error', position: 'top' })
    } finally {
      setIsLoading(false)
    }
  }

  async function saveConfig() {
    setIsLoadingSave(true)
    const formData = new FormData()

    formData.append('message_text', message)
    formData.append('send_time', scheduleTime)
    formData.append('is_active', isActive === true ? '1' : '0')

    if (photo && !(typeof photo === 'string' && photo.startsWith('http'))) {
      formData.append('image', photo)
    }


    try {
      await apiAuth.post('clinics/whatsapp/automation/update_config/', formData)
      toast({ title: 'Configuração salva com sucesso', status: 'success', position: 'top' })
    } catch {
      toast({ title: 'Erro ao salvar configuração', status: 'error', position: 'top' })
    } finally {
      setIsLoadingSave(false)
    }
  }


  async function fetchLogs() {
    try {
      const { data } = await apiAuth.get('clinics/whatsapp/automation-log/')
      const formatted = data?.results?.map((log: any) => ({
        id: log.id,
        envioData: log.date,
        startTime: log.start_time,
        endTime: log.end_time,
        successCount: log.success_count,
        failureCount: log.failure_count,
      }))
      setHistoryData(formatted)
      if (formatted.length > 0) {
        const last = formatted[formatted.length - 1]
        setLastStartTime(last.startTime)
        setLastEndTime(last.endTime)
        setSuccessCount(last.successCount)
        setFailureCount(last.failureCount)
      }
      setTotalCountOfPage(formatted.length)
    } catch {
      toast({ title: 'Erro ao carregar histórico', status: 'error', position: 'top' })
    }
  }

  useEffect(() => {
    const InitialData = async () => {
      await fetchConfig()
      await fetchLogs()
      setIsLoading(false)
    }

    InitialData()

    return () => {}
  }, [])


  useEffect(() => {
      return () => {
        if (previewUrl) {
          URL.revokeObjectURL(previewUrl)
        }
    }
  }, [previewUrl])

  const handlePhotoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0]
      setPhoto(file)

      const objectUrl = URL.createObjectURL(file)
      setPreviewUrl(objectUrl)
    }
  }

  function onEmojiClick(emojiObject: { emoji: string }) {
    setMessage((prev) => prev + emojiObject.emoji)
  }

  function onFocusInput() {
    setShowEmoji(false)
  }

  const renderTableBody = () => {
    if (isLoading) {
      return (
        <>
          {[...Array(3)].map((_, idx) => (
            <Tr key={idx}>
              <Td>
                <Skeleton height="20px" />
              </Td>
              <Td>
                <Skeleton height="20px" />
              </Td>
              <Td>
                <Skeleton height="20px" />
              </Td>
              <Td>
                <Skeleton height="20px" />
              </Td>
              <Td>
                <Skeleton height="20px" />
              </Td>
              <Td>
                <Skeleton height="20px" />
              </Td>
            </Tr>
          ))}
        </>
      )
    }

    if (historyData.length > 0) {
      return historyData.map((record) => (
        <Tr key={record.id}>
          <Td>
            <Text fontSize="sm">{record.envioData}</Text>
          </Td>
          <Td>
            <Text fontSize="sm">{record.startTime}</Text>
          </Td>
          <Td>
            <Text fontSize="sm">{record.endTime}</Text>
          </Td>
          <Td>
            <Text fontSize="sm" color="green.600">
              {record.successCount}
            </Text>
          </Td>
          <Td>
            <Text fontSize="sm" color="red.600">
              {record.failureCount}
            </Text>
          </Td>
          <Td>
            <Link to={`/history/details/${record.id}`}>
              <Tooltip label="Detalhar" hasArrow placement="top">
                <Flex ml="1rem" w="24px" cursor="pointer">
                  <FiEdit size={16} color="#9699B0" />
                </Flex>
              </Tooltip>
            </Link>
          </Td>
        </Tr>
      ))
    }

    return (
      <Tr>
        <Td colSpan={6}>
          <NotFound />
        </Td>
      </Tr>
    )
  }

  if (isLoading) {
    return (
      <Box overflow="hidden" position="relative">
        <Header>
          <Flex
            mx="auto"
            w="100%"
            direction="row"
            my="6"
            align="center"
            justify="center"
          >
            <Box mx="auto">
              <Text fontSize="24px" fontWeight="600">
                {t('title')}
              </Text>
            </Box>
          </Flex>
        </Header>
        <Sidebar />
        <Flex
          flex="1"
          mx="auto"
          ml={isWideVersion ? '75px' : '2'}
          mt="15px"
          mb="8px"
          mr="2"
          bg="white"
          h="calc(100vh - 60px)"
          align="center"
          justify="center"
        >
          <Spinner color="blue" />
        </Flex>
      </Box>
    )
  }

  return (
    <Box position="relative">
      <Header>
        <Flex
          mx="auto"
          w="100%"
          direction="row"
          my="6"
          align="center"
          justify="center"
        >
          <Box mx="auto">
            <Text fontSize="24px" fontWeight="600">
              {t('title')}
            </Text>
          </Box>
        </Flex>
      </Header>
      <Sidebar />

      <Flex
        flex="1"
        mx="auto"
        ml={isWideVersion ? '75px' : '2'}
        mt="15px"
        mb="8px"
        mr="2"
        bg="white"
        h="calc(100vh - 60px)"
      >
        <Stack spacing="6" w="100%">
          <CardContainer title={t('containerOne.title')}>
            <Stack spacing="4" position="relative">
              <FormControl>
                <FormLabel>Mensagem (com emoticons)</FormLabel>
                <Textarea
                  placeholder="Digite sua mensagem aqui..."
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  onFocus={onFocusInput}
                />
              </FormControl>
              <Box w="320px">
                <Button onClick={() => setShowEmoji((prev) => !prev)} colorScheme="purple">
                  {showEmoji ? 'Fechar Emoticons' : 'Adicionar Emoticons'}
                </Button>
                {showEmoji && (
                  <Flex position="absolute" mt="4" zIndex={999}>
                    <Picker onEmojiClick={onEmojiClick} />
                  </Flex>
                )}
              </Box>

              <FormControl>
                <FormLabel>
                  Palavra-chave para nome social do paciente
                </FormLabel>
                <Input placeholder="Ex: NomeSocial" value={socialKeyword} isReadOnly />
              </FormControl>

              <FormControl display="flex" alignItems="center">
                <FormLabel mb="0">Ativar disparo diário?</FormLabel>
                <Switch
                  colorScheme="green"
                  isChecked={isActive}
                  onChange={() => setIsActive(!isActive)}
                />
              </FormControl>

              <FormControl>
                <FormLabel>Horário do disparo diário</FormLabel>
                <Input
                  type="time"
                  value={scheduleTime}
                  onChange={(e) => setScheduleTime(e.target.value)}
                />
              </FormControl>

              <FormControl>
                <FormLabel>Imagem da mensagem (opcional)</FormLabel>

                {!photo && (
                  <Button
                    as="label"
                    htmlFor="file-input"
                    leftIcon={<AddIcon />}
                    colorScheme="blue"
                    variant="outline"
                    w="50px"
                    h="50px"
                    border="2px dashed"
                    borderColor="blue.300"
                    borderRadius="xl"
                    justifyContent="center"
                    fontSize="lg"
                    cursor="pointer"
                  >
                    +
                    <Input
                      id="file-input"
                      type="file"
                      accept="image/*"
                      display="none"
                      onChange={handlePhotoChange}
                    />
                  </Button>
                )}

                {photo && previewUrl && (
                  <Box mt="4" position="relative" display="inline-block">
                    <img
                      src={previewUrl}
                      alt="preview"
                      style={{
                        width: '50px',
                        height: '50px',
                        objectFit: 'cover',
                        borderRadius: '10px',
                        border: '1px solid #e2e8f0',
                      }}
                    />
                    <Button
                      size="xs"
                      colorScheme="red"
                      position="absolute"
                      top="5px"
                      right="5px"
                      borderRadius="full"
                      onClick={() => {
                        if (previewUrl) URL.revokeObjectURL(previewUrl)
                        setPreviewUrl(null)
                        setPhoto(null)
                      }}
                    >
                      <CloseIcon w={2} h={2} />
                    </Button>
                  </Box>
                )}
              </FormControl>

              <Button onClick={saveConfig} isLoading={isLoadingSave} bgColor="blue.300" color="white">
                salvar configuração
              </Button>
            </Stack>
          </CardContainer>

          {message && photo && (
            <WhatsAppMessagePreviewReal  message={message} photoUrl={previewUrl} />
          )}

          <CardContainer title="Último Envio">
            <Stack spacing="3">
              <Flex justify="space-between">
                <Text fontWeight="bold">Hora Inicial:</Text>
                <Text color="green.500">{lastStartTime || '-'}</Text>
              </Flex>
              <Flex justify="space-between">
                <Text fontWeight="bold">Hora Final:</Text>
                <Text color="blue.500">{lastEndTime || '-'}</Text>
              </Flex>
              <Flex justify="space-between">
                <Text fontWeight="bold">Envios com Sucesso:</Text>
                <Text color="green.600">
                  {successCount !== null ? successCount : 0}
                </Text>
              </Flex>
              <Flex justify="space-between">
                <Text fontWeight="bold">Envios com Falha:</Text>
                <Text color="red.600">
                  {failureCount !== null ? failureCount : 0}
                </Text>
              </Flex>
            </Stack>
          </CardContainer>

          <CardContainer title="Histórico de Envios">
            <Box overflowX="auto">
              <Table variant="striped" colorScheme="blue" size="sm">
                <Thead>
                  <Tr>
                    <Th>Data do Envio</Th>
                    <Th>Hora Inicial</Th>
                    <Th>Hora Final</Th>
                    <Th color="green.600">Sucesso</Th>
                    <Th color="red.600">Falha</Th>
                    <Th>Ação</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {renderTableBody()}
                </Tbody>
              </Table>
            </Box>
            {totalCountOfPage !== 0 && !isLoading && (
              <Pagination
                totalCountOfRegisters={totalCountOfPage}
                currentPage={currentPage}
                onPageChange={setCurrentPage}
              />
            )}
          </CardContainer>
        </Stack>
      </Flex>
      <Flex w="100%" h="1000px" />
    </Box>
  )
}
